import { Box, FormControlLabel, Switch, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="default" />
			<Text semiBold text="block" />
			<Text semiBold text="fullWidth" />
			<Box border="1px solid silver" p={1}>
				<FormControlLabel
					control={<Switch checked={false} />}
					label="Label 1"
					labelPlacement="start"
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label="Label 2"
					labelPlacement="start"
				/>
			</Box>
			<Box border="1px solid silver" p={1}>
				<FormControlLabel
					block
					control={<Switch checked={false} />}
					label="Label 1"
					labelPlacement="start"
				/>
				<FormControlLabel
					block
					control={<Switch checked={false} />}
					label="Label 2"
					labelPlacement="start"
				/>
			</Box>
			<Box border="1px solid silver" p={1}>
				<FormControlLabel
					control={<Switch checked={false} />}
					fullWidth
					label="Label 1"
					labelPlacement="start"
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					fullWidth
					label="Label 2"
					labelPlacement="start"
				/>
			</Box>
		</CssColumnGrid>
	);
};